import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query/react';

import docViewerAPI from './api/DocViewerAPI';
import userSlice from './features/User';

const middlewares = [docViewerAPI.middleware];

if (process.env.NODE_ENV === `development`) {
  const {createLogger} = require(`redux-logger`);
  const logger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error,
    predicate: (getState, action) =>
      action.type !== '__rtkq/focused' && action.type !== '__rtkq/unfocused',
  });

  middlewares.push(logger);
}

export const store = configureStore({
  reducer: {
    [userSlice.name]: userSlice.reducer,
    // Add the generated reducer as a specific top-level slice
    [docViewerAPI.reducerPath]: docViewerAPI.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middlewares),
});

setupListeners(store.dispatch);
